import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_main-ui/_protected/')({
  component: () => <Navigate to="/promotions" search={{ ref: 'home' }} />,
});
